import 'es6-promise/auto'
import Vue from 'vue'
import VueResource from 'vue-resource'
import router from './routes'
import App from './app.vue'
import store from './store'
import Wui from 'wui'
import directives from './utils/directives'
import filters from './utils/filters'
import * as components from './utils/components/'
import { trackPageView } from './utils/libs/track'

import 'wui/dist/wui.css'
import './assets/sass/base.scss'
import './assets/sass/app.scss'
// Vue无缝滚动
import scroll from 'vue-seamless-scroll'
import VueCookies from 'vue-cookies'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
Vue.use(VueResource)
Vue.use(Wui)
Vue.use(directives)
Vue.use(filters)
Vue.use(scroll)
Vue.use(VueCookies)

// Vue.http.options.emulateJSON = true;
// Vue.http.options.xhr = { withCredentials: true }

Vue.http.options.headers = {
    'Content-Type': 'application/json'
}

// 允许发送cookie
Vue.http.interceptors.push((request, next) => {
    request.credentials = true
    //request.headers.set('X-Requested-With', 'XMLHttpRequest');
    next()
})

Vue.http.interceptors.push((request, next) => {
    var timeout

    // 有設置值就啟動一個定時器
    if (request.timeout) {
        timeout = setTimeout(() => {
            if (typeof request.onTimeout === 'function') request.onTimeout(request)
            request.abort()
            //Wui.Toast.show('网络异常，请稍后重试')
        }, request.timeout)
    }

    next(() => {
        clearTimeout(timeout)
    })
})

Vue.directive('title', {
    inserted: function (el, binding) {
        document.title = el.dataset.title
    }
})

// 自定义组件
Object.keys(components).forEach((c) => {
    const cm = components[c]
    Vue.component(cm.name, cm)
})

// set rem base
//window.addEventListener('DOMContentLoaded', function(){
var _clientWidth = document.documentElement.clientWidth
var _clienHeight = document.documentElement.clientHeight
var dpr = window.devicePixelRatio || 1
document.documentElement.style.fontSize = (100 * _clientWidth) / 375 + 'px'
document.documentElement.dataset.ch = _clienHeight
document.documentElement.dataset.cw = _clientWidth
//});

// 对接光大银行app回调方法
window.getCodeCallback = (code) => {
    setTimeout(() => {
        sessionStorage.setItem('code', code)
    }, 1000)
}

new Vue({
    store,
    router,
    ...App
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/app.js